import {Pressable, Text, StyleSheet} from "react-native";
import React from "react";
import {useSelector} from "react-redux";
import {useTheme} from "@react-navigation/native";

export default function AddTaskButton(props) {
    const { onPress, title = 'Save' } = props;

    const theme = useTheme();
    const styles = StyleSheet.create({
        button: {
            display: 'flex',
            width:64,
            height:64,
            alignItems:'center',
            justifyContent:'center',
            backgroundColor: theme.colors.scheme[1],
            fontFamily: 'Roboto-Regular',
            marginHorizontal:2,
            borderWidth: 0,
            borderRadius:100,
            textAlign:'center'
        }
    });
    return (
        <Pressable style={({pressed}) => [styles.button, {opacity: pressed ? 0.5 : 1}]} onPress={onPress}>
            {title}
        </Pressable>
    );
}